import { render, staticRenderFns } from "./CardTotal.vue?vue&type=template&id=b5d995ba&scoped=true&"
import script from "./CardTotal.vue?vue&type=script&lang=js&"
export * from "./CardTotal.vue?vue&type=script&lang=js&"
import style0 from "./CardTotal.vue?vue&type=style&index=0&id=b5d995ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d995ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
